// extracted by mini-css-extract-plugin
export default {"two-column-slide":"TwoColumnSlide_two-column-slide__XDMN1"};